export function isConversationIssueText(text: string | null | undefined): boolean {
  const value = text?.trim();
  if (!value) {
    return false;
  }
  return (
    value.startsWith("⚠️") ||
    /rate limit|failed before reply|unavailable|quota|try again later/i.test(value)
  );
}

export function getLatestConversationIssue(
  messages: Array<{ role?: string | null; text?: string | null }>,
): string | null {
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    const message = messages[index];
    if (message?.role === "user") {
      return null;
    }
    if (message?.role === "assistant") {
      return isConversationIssueText(message.text) ? message.text?.trim() || null : null;
    }
  }
  return null;
}
